import { useCallback, useState } from 'react';

import { CodingAgentId } from './types';

/**
 * Controller hook that owns the multi-select state for the coding-agent
 * selection screen. Kept as a thin wrapper so it can be tested in
 * isolation and so the View remains a dumb component.
 */
export const useCodingAgentSelection = (initial: CodingAgentId[] = []) => {
	const [selected, setSelected] = useState<CodingAgentId[]>(initial);

	const toggle = useCallback((id: CodingAgentId) => {
		setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
	}, []);

	const clear = useCallback(() => setSelected([]), []);

	return { selected, toggle, clear, setSelected };
};
